import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isExternalCampaignHref } from '../pages/campaigns';

function isDismissed(id, placement) {
  try {
    return localStorage.getItem(`campaign_dismissed_${id}_${placement}`) === '1';
  } catch {
    return false;
  }
}

function dismiss(id, placement) {
  try {
    localStorage.setItem(`campaign_dismissed_${id}_${placement}`, '1');
  } catch {
    // ignore
  }
}

function CampaignCta({ campaign, onClick, className }) {
  if (isExternalCampaignHref(campaign.ctaTo)) {
    return (
      <a
        className={className}
        href={campaign.ctaTo}
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {campaign.ctaLabel}
      </a>
    );
  }
  return (
    <Link className={className} to={campaign.ctaTo} state={campaign.ctaState} onClick={onClick}>
      {campaign.ctaLabel}
    </Link>
  );
}

export default function CampaignLayer({ campaigns }) {
  const location = useLocation();

  const active = (placement) =>
    (campaigns || []).find(
      (c) =>
        c &&
        c.enabled &&
        Array.isArray(c.placements) &&
        c.placements.includes(placement) &&
        !isDismissed(c.id, placement),
    );

  const top = active('top_bar');
  const floating = active('floating');
  const popup = active('popup');

  const [popupOpen, setPopupOpen] = React.useState(Boolean(popup));
  React.useEffect(() => {
    setPopupOpen(Boolean(popup));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <>
      {top && (
        <div className="campaign-topbar" role="region" aria-label="Aktuális akció">
          <div className="campaign-topbar-inner">
            <div className="campaign-topbar-text">
              <strong>{top.title}</strong>
              <span className="campaign-topbar-sep">•</span>
              <span className="campaign-topbar-body">{top.body}</span>
              {Array.isArray(top.routes) && top.routes.length > 0 && (
                <>
                  <span className="campaign-topbar-sep">•</span>
                  <span className="campaign-topbar-routes">
                    {top.routes.slice(0, 2).map((r) => `${r.from} → ${r.to}`).join(' · ')}
                    {top.routes.length > 2 ? ' · …' : ''}
                  </span>
                </>
              )}
            </div>
            <div className="campaign-topbar-actions">
              <CampaignCta
                campaign={top}
                className="nav-pill nav-pill-cta campaign-topbar-cta"
                onClick={() => dismiss(top.id, 'top_bar')}
              />
              <button
                type="button"
                className="campaign-close"
                aria-label="Bezárás"
                onClick={() => {
                  dismiss(top.id, 'top_bar');
                  // force rerender by updating state via location change not needed; bar will disappear on next render
                  window.dispatchEvent(new Event('storage'));
                }}
              >
                ×
              </button>
            </div>
          </div>
        </div>
      )}

      {floating && (
        <div className="campaign-floating" aria-label="Aktuális akció">
          <div className="campaign-floating-card">
            <button
              type="button"
              className="campaign-close"
              aria-label="Bezárás"
              onClick={() => {
                dismiss(floating.id, 'floating');
                window.dispatchEvent(new Event('storage'));
              }}
            >
              ×
            </button>
            <div className="campaign-floating-title">{floating.title}</div>
            <div className="campaign-floating-body">{floating.body}</div>
            <CampaignCta
              campaign={floating}
              className="nav-pill campaign-floating-cta"
              onClick={() => dismiss(floating.id, 'floating')}
            />
          </div>
        </div>
      )}

      {popup && popupOpen && (
        <div className="campaign-modal-backdrop" onClick={() => setPopupOpen(false)}>
          <div
            className="campaign-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <button
              type="button"
              className="campaign-close"
              aria-label="Bezárás"
              onClick={() => {
                dismiss(popup.id, 'popup');
                setPopupOpen(false);
              }}
            >
              ×
            </button>
            <h3 className="campaign-modal-title">{popup.title}</h3>
            <p className="campaign-modal-body">{popup.body}</p>
            <div className="campaign-modal-actions">
              <button
                type="button"
                className="nav-pill"
                onClick={() => {
                  dismiss(popup.id, 'popup');
                  setPopupOpen(false);
                }}
              >
                Most nem
              </button>
              <CampaignCta
                campaign={popup}
                className="nav-pill nav-pill-cta"
                onClick={() => {
                  dismiss(popup.id, 'popup');
                  setPopupOpen(false);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

